import userStore from "./userStore";
import supportCallsStore from "./supportCallsStore";
import reportDetailsStore from "./reportDetailsStore";
import tasksStore from "./tasksStore";
import monthReportsStore from "./monthReportsStore";
import customersConnectionsStore from "./customersConnectionsStore";

const stores = {
  userStore,
  supportCallsStore,
  reportDetailsStore,
  tasksStore,
  monthReportsStore,
  customersConnectionsStore,
};

export { userStore, supportCallsStore };

export default stores;
